import React, { useState, useEffect } from 'react';

const COOKIE_KEY = 'compify-cookie-consent';

const defaultPrefs = {
  essential: true,
  analytics: false,
  marketing: false,
};

function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [prefs, setPrefs] = useState(defaultPrefs);

  useEffect(() => {
    const saved = localStorage.getItem(COOKIE_KEY);
    if (!saved) setVisible(true);
  }, []);

  const save = (choices) => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify(choices));
    setVisible(false);
  };

  const acceptAll = () => save({ essential: true, analytics: true, marketing: true });
  const refuseAll = () => save({ essential: true, analytics: false, marketing: false });
  const saveCustom = () => save(prefs);

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 99999,
      backgroundColor: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Arial, sans-serif',
    }}>
      <div style={{
        backgroundColor: '#1A1A1A', color: '#fff',
        width: '100%', maxWidth: '480px', margin: '16px',
        padding: '32px', boxShadow: '0 8px 40px rgba(0,0,0,0.6)',
        position: 'relative',
      }}>
        {/* Coins décoratifs */}
        {[
          { top: 0, left: 0, borderTop: '2px solid #FF0066', borderLeft: '2px solid #FF0066' },
          { top: 0, right: 0, borderTop: '2px solid #FF0066', borderRight: '2px solid #FF0066' },
          { bottom: 0, left: 0, borderBottom: '2px solid #FF0066', borderLeft: '2px solid #FF0066' },
          { bottom: 0, right: 0, borderBottom: '2px solid #FF0066', borderRight: '2px solid #FF0066' },
        ].map((corner, i) => (
          <div key={i} style={{ position: 'absolute', width: '12px', height: '12px', ...corner }} />
        ))}

        {/* Logo */}
        <p style={{ margin: '0 0 16px', fontSize: '14px', fontWeight: '900', letterSpacing: '4px', color: '#FF0066' }}>COMPIFY</p>

        {/* Titre */}
        <p style={{ margin: '0 0 12px', fontSize: '16px', fontWeight: '700', letterSpacing: '1px' }}>
          Nous utilisons des cookies 🍪
        </p>

        {/* Texte */}
        <p style={{ margin: '0 0 20px', fontSize: '12px', color: '#aaa', lineHeight: '1.6' }}>
          Compify utilise des cookies pour améliorer votre expérience, mémoriser vos préférences et afficher des publicités pertinentes. Vous pouvez personnaliser vos choix ci-dessous.
        </p>

        {/* Détails personnalisation */}
        {showDetails && (
          <div style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {[
              { key: 'essential', label: 'Essentiels', desc: 'Nécessaires au fonctionnement du site', locked: true },
              { key: 'analytics', label: 'Analytiques', desc: 'Mesure d\'audience et statistiques' },
              { key: 'marketing', label: 'Marketing', desc: 'Publicités personnalisées' },
            ].map(item => (
              <div key={item.key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: 'rgba(255,255,255,0.05)', padding: '10px 12px' }}>
                <div>
                  <p style={{ margin: 0, fontSize: '12px', fontWeight: '700', color: '#fff' }}>{item.label}</p>
                  <p style={{ margin: '2px 0 0', fontSize: '10px', color: '#888' }}>{item.desc}</p>
                </div>
                <div
                  onClick={() => { if (!item.locked) setPrefs(prev => ({ ...prev, [item.key]: !prev[item.key] })); }}
                  style={{
                    width: '36px', height: '18px', borderRadius: '9px', cursor: item.locked ? 'not-allowed' : 'pointer',
                    backgroundColor: (item.locked || prefs[item.key]) ? '#FF0066' : '#444',
                    position: 'relative', transition: 'all 0.2s', flexShrink: 0,
                  }}>
                  <div style={{
                    position: 'absolute', top: '3px',
                    left: (item.locked || prefs[item.key]) ? '21px' : '3px',
                    width: '12px', height: '12px', borderRadius: '50%',
                    backgroundColor: '#fff', transition: 'all 0.2s'
                  }} />
                </div>
              </div>
            ))}
            <button onClick={saveCustom} style={{
              width: '100%', padding: '10px', backgroundColor: 'transparent',
              border: '1px solid #FF0066', color: '#FF0066', cursor: 'pointer',
              fontSize: '11px', fontWeight: '700', letterSpacing: '2px', marginTop: '4px',
            }}>
              SAUVEGARDER MES PRÉFÉRENCES
            </button>
          </div>
        )}

        {/* Boutons principaux */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <button onClick={acceptAll} style={{
            width: '100%', padding: '12px', backgroundColor: '#FF0066',
            border: 'none', color: '#fff', cursor: 'pointer',
            fontSize: '11px', fontWeight: '700', letterSpacing: '2px',
          }}>
            ACCEPTER TOUT
          </button>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={refuseAll} style={{
              flex: 1, padding: '10px', backgroundColor: 'transparent',
              border: '1px solid #444', color: '#888', cursor: 'pointer',
              fontSize: '11px', fontWeight: '700', letterSpacing: '2px',
            }}>
              REFUSER
            </button>
            <button onClick={() => setShowDetails(prev => !prev)} style={{
              flex: 1, padding: '10px', backgroundColor: 'transparent',
              border: '1px solid #444', color: '#888', cursor: 'pointer',
              fontSize: '11px', fontWeight: '700', letterSpacing: '2px',
            }}>
              {showDetails ? 'MASQUER' : 'PERSONNALISER'}
            </button>
          </div>
        </div>

        {/* Lien politique */}
        <p style={{ margin: '16px 0 0', fontSize: '10px', color: '#555', textAlign: 'center' }}>
          En savoir plus sur notre{' '}
          <a href="/confidentialite" style={{ color: '#FF0066', textDecoration: 'none' }}>politique de confidentialité</a>
        </p>
      </div>
    </div>
  );
}

export default CookieConsent;